// extracted by mini-css-extract-plugin
export default {"fadeInEffect":"FadeInTitle_fadeInEffect__+Vexc","scale":"FadeInTitle_scale__-iHjb","titleWord":"FadeInTitle_titleWord__8M5IF","fade-in":"FadeInTitle_fade-in__9U2KG"};